import styles from './StateMessage.module.scss';
import { FC } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import { useFocusOnMount } from '../../useFocusOnMount';

interface StateMessageProps {
  title: string;
  body?: string;
  action?: { label: string; onClick: () => void };
  /** Moves focus to the title, for a state reached by pressing a control. */
  focusTitle?: boolean;
}

/**
 * A terminal state of the booking page: the link has expired, nothing is on
 * offer, the link is not valid, or the call failed. Announced as a status so
 * a screen reader hears the outcome without the candidate hunting for it.
 */
const StateMessage: FC<StateMessageProps> = ({
  title,
  body,
  action,
  focusTitle = false,
}) => {
  const titleRef = useFocusOnMount<HTMLHeadingElement>(focusTitle);

  return (
    <div className={styles.wrapper} role="status">
      <h1
        className={styles.title}
        ref={titleRef}
        tabIndex={focusTitle ? -1 : undefined}
      >
        {title}
      </h1>
      {body && <p className={styles.body}>{body}</p>}
      {action && (
        <Button variant="secondary" size="medium" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
};

export default StateMessage;
